export const SIGN_IN_PATH = '/sign-in';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const FORGOT_USERNAME_PATH = '/forgot-username';
export const RESET_PASSWORD_PATH = '/reset-password';
export const ACCOUNT_PATH = '/account';
export const CHANGE_PASSWORD_PATH = '/change-password';
export const USER_MANAGEMENT_PATH = '/user-management';
export const USER_CREATION_PATH = '/user-creation';
export const USER_DETAILS_PATH = '/user-details';
export const TENANT_PATH = '/tenants';
export const FACILITIES_PATH = '/facilities';
export const ZONES_PATH = '/zones';
export const DEVICE_CONFIG_PATH = '/device-config';
export const RULES_CONFIG_PATH = '/rules-config';
export const REPORTS_LIST_PATH = '/reports-list';
export const CREATE_REPORT_PATH = '/create-report';
export const CREATE_COLUMN_PATH = '/create-column';
export const EDIT_REPORT_PATH = '/edit-report';
export const ASSET_DATA_IMPORT_PATH = '/asset-data';
export const MANAGE_GROUP_TYPE_PATH = '/manage-group-types';
export const DATA_MODEL_TYPE_PATH = '/manage-data-model-type';
export const CREATE_GROUP_TYPE_PATH = '/create-group-type';
export const EDIT_GROUP_TYPE_PATH = '/edit-group-type';
export const CREATE_DEVICE_PATH = '/create-device';
export const EDIT_DEVICE_PATH = '/edit-device';
export const CREATE_REPORT_GROUP_PATH = '/create-report-group';
export const EDIT_REPORT_GROUP_PATH = '/edit-report-group';
export const MAP_REPORT_PATH = '/map-report';
export const DATA_MODEL_EDIT_PATH = '/edit-model';
export const DATA_MODEL_DIAGRAM_PATH = '/data-model-diagram';
